module.exports = __webpack_public_path__ + "static/media/desktop5.aa004a4b.png";